import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const words = ["Hi, I'm Shristi", "Backend Developer", "AI Engineer"];

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);

  const typingSpeed = 150;
  const deletingSpeed = 100;
  const pauseTime = 2000;

  useEffect(() => {
    const handleTyping = () => {
      const currentWord = words[loopNum % words.length];
      const updatedText = isDeleting
        ? currentWord.substring(0, currentIndex - 1)
        : currentWord.substring(0, currentIndex + 1);

      setDisplayText(updatedText);

      if (!isDeleting && updatedText === currentWord) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + (isDeleting ? -1 : 1));
      }
    };

    const timer = setTimeout(handleTyping, isDeleting ? deletingSpeed : typingSpeed);
    return () => clearTimeout(timer);
  }, [currentIndex, isDeleting, loopNum]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">



      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="typing-text">{displayText}<span className="cursor">|</span></h1>
            <p className="hero-subtitle">Software Engineering Enthusiast  |  Backend Developer  |  AI Engineer</p>
            <div className="hero-buttons">
              <motion.button
                className="btn-primary"
                onClick={() => scrollToSection('projects')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                View Projects
              </motion.button>
              <motion.button
                className="btn-primary"
                onClick={() => scrollToSection('contact')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Contact Me
              </motion.button>
             <button
  className="btn-primary"
  onClick={() =>
    window.open(
      'https://drive.google.com/file/d/1W3rlI2zNmGFURTYWO-A6jMmP8_O-CBJx/view?usp=sharing',
      '_blank'
    )
  }
>
  Resume
</button>
            </div>
          </motion.div>

          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="image-container">
              <img src="/dp.jpeg" alt="Shristi" className="profile-img" />
              <div className="image-glow"></div>
            </div>
          </motion.div>
        </motion.div>
{/* 
        <motion.div
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
          {/* <p>Scroll Down</p> */}
        {/* </motion.div> */} 
      </div>
    </section>
  );
};

export default Hero;